import Annotation from '@/classes/Annotation';

export default class TrainingDataItem {
  modelName: string | null;
  text: string | null;
  annotations: Annotation[];

  constructor(init?: TrainingDataItem) {
    if (init) {
      this.modelName = init.modelName ?? null;
      this.text = init.text ?? null;
      if (init.annotations && Array.isArray(init.annotations)) {
        this.annotations = init.annotations.map((a:any) => new Annotation(a));
      } else {
        this.annotations = [];
      }
    } else {
      this.modelName = null;
      this.text = null;
      this.annotations = [];
    }
  }
}
